<template>
  <div class="col-md-3 col-lg-2">
    <div class="card card-decrypt-key">
      <div class="card-header">
        <div>
          <h5 class="card-title">{{ siteini.site }}</h5>
          <div class="label pull-right" :class="labelClass">{{ labelText }}</div>
          <hr>
        </div>
      </div>
      <div class="card-content">

        <div class="row d-flex align-items-center">
          <div class="col-md-12">
            <div class="form-group">
              <input type="text" placeholder="site.ini decrypt key" class="form-control" v-model="forms.decryptKeySet.key"/>
            </div>
            <div class="form-group text-center">
              <button class="btn btn-fill btn-info" @click.prevent="submitDecryptKey">Update</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from 'vuex'

export default {
  props: {
    siteini: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted () {
    this.forms.decryptKeySet.id = this.siteini.id;
    this.forms.decryptKeySet.key = this.decryptKeyText;
  },
  data: function () {
    return {
      forms: {
        decryptKeySet: {
          id: '',
          key: ''
        }
      },
      statusData: {
        1: {label: 'Empty', class: 'label-warning'},
        2: {label: 'Set', class: 'label-info'},
        // 2: {label: 'Pending', class: 'label-info'},
        3: {label: 'Valid', class: 'label-success'},
        4: {label: 'Invalid', class: 'label-danger'},
      }
    }
  },
  computed: {
    decryptKey: function () {
      return this.siteini.decrypt_key;
    },
    decryptKeyStatus: function () {
      if (this.decryptKey) {
        return this.decryptKey.status;
      }
      return 1;
    },
    decryptKeyText: function () {
      if (this.decryptKey) {
        return this.decryptKey.key;
      }
      return '';
    },
    labelClass: function () {
      const keyStatus = this.decryptKeyStatus;
      return this.statusData[keyStatus].class;
    },
    labelText: function () {
      const keyStatus = this.decryptKeyStatus;
      return this.statusData[keyStatus].label;
    }
  },
  methods: {
    ...mapActions(['siteiniDecryptKeyUpdate']),
    submitDecryptKey: function () {
      this.siteiniDecryptKeyUpdate(this.forms.decryptKeySet);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DecryptKey/List/KeyCard.vue